export default "__VITE_ASSET__CO0UeE8I__"